import { ManageService } from './../../services/manage.service';
import { Router, ActivatedRoute } from '@angular/router';
import { ManageByPerpetual } from './../../models/imanage.model';
import { Component, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { NgProgress } from 'ngx-progressbar';
import { NgProgressService } from '../../services/ngProgress.service';

declare var $: any;

@Component({
  selector: 'app-manage-perpetuals-programtypes',
  templateUrl: './manage-perpetuals-programtypes.component.html',
  styleUrls: ['./manage-perpetuals-programtypes.component.css']
})
export class ManagePerpetualsProgramtypesComponent implements OnInit {

  title = 'PERPETUAL';
  searchField = '';

  setFullWindow: boolean = false;

  perpetuals: ManageByPerpetual[];
  programType: string;

  //Pagination
  p: number = 1;
  itemsPerPage: number = 10;
  totalItems: number;
  showPager: boolean = false;

  //Items
  items: ManageByPerpetual[];

  @ViewChild('entry', { read: ViewContainerRef })
  entry: ViewContainerRef;

  constructor(
    private router: Router,
    private activatedroute: ActivatedRoute,
    private manageService: ManageService,
    public ngProgress: NgProgressService
  ) { }

  ngOnInit() {
    this.ngProgress.start();

    this.activatedroute.paramMap.subscribe(params => {
      this.programType = params.get('programtype');

      this.title = this.title + ' - ' + this.programType;
    });

    this.manageService.getPerpetualsByType(this.programType).subscribe((value: ManageByPerpetual[]) => {
      this.totalItems = value.length;
      this.perpetuals = value;
      if (this.totalItems > 10)
         this.showPager = true;
      
      this.ngProgress.done();
      $('.page-contents').animate({ scrollLeft: $('#levelOne').width() }, 400);
    },
    (error: any) => {
        console.info(error);
        this.ngProgress.done();
    });
  }

  
  close() { this.ngProgress.done();
    $('.page-contents').animate({ scrollLeft: -$('#levelOne').width() }, 400);
    this.router.navigateByUrl('/managePerpetuals');
  }

}
